import { render, staticRenderFns } from "./SingleLayerClusterStyle.vue?vue&type=template&id=a051c816&scoped=true"
import script from "./SingleLayerClusterStyle.vue?vue&type=script&lang=ts"
export * from "./SingleLayerClusterStyle.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerClusterStyle.vue?vue&type=style&index=0&id=a051c816&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a051c816",
  null
  
)

export default component.exports